// extracted by mini-css-extract-plugin
module.exports = {"indicator":"_2sAaZ4WaJi33xKyvfutfRq","variant-alert":"_2nLKX-usygu6maDP1Hb778","variant-presence":"_2UtdO15uzWCnDrazmkjhdX"};